import { Icon } from "@mui/material";
import DynamicIcon from "../dynamicicon";

function FlowItem({ flow, pos, code, title, isLast = false }) {
  const flow_class = (p, c) => {
    return `item `;
  };

  const isActive = flow.pos >= pos;

  return (
    <div
      style={{
        color: `${isActive ? "var(--primary)" : "var(--windowcolor)"}`,
        display: "flex",
        flexDirection: "row",
        margin: 8,
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="flow-item-content"
      >
        <div
          className="circle-only"
          style={{
            backgroundColor: `${
              isActive ? "var(--primary)" : "var(--windowcolor)"
            }`,
          }}
        ></div>
        <div>{title}</div>
      </div>
      {!isLast && (
        <div className="line" style={{ width: 41, marginTop: 20 }}>
          <hr />
        </div>
      )}
    </div>
  );
}

export default FlowItem;
